import React from 'react'
import { Grid } from '@mui/material'
import { StyledButton } from 'shared'
import { useProfileForm } from 'utils/providers/ProfileFormProvider'
import { makeStyles } from '@mui/styles'
import { useAuth } from 'utils/providers/AuthProvider'

const useStyles = makeStyles((theme) => {
  return {
    buttonsContainer: {
      justifyContent: 'space-between',
      [theme.breakpoints.down('sm')]: {
        '& button': {
          width: '100%',
        },
      },
    },
  }
})

export const StickyButtons = () => {
  const classes = useStyles()
  const { logout } = useAuth()
  const { activeStep, onStepChange, totalSteps, steps } = useProfileForm()

  const isFirstStep = activeStep === 0
  const isLastStep = activeStep === totalSteps - 1

  const goBack = () => {
    if (steps[activeStep]) {
      steps[activeStep].onBack()
    }
    if (!isFirstStep) {
      return onStepChange(activeStep - 1, null)
    }
    logout()
  }

  const goForward = () => {
    const form = document.querySelector(
      '#profile-form'
    ) as HTMLFormElement | null

    if (!form) return

    form.requestSubmit()
  }

  return (
    <Grid
      bottom={0}
      width="100%"
      paddingY="12px"
      position="sticky"
      boxShadow="0px -2px 10px 0px #EFECF1"
      marginTop="auto"
      sx={{ backgroundColor: ({ palette }) => palette.common.white }}
    >
      <Grid
        margin="0 auto"
        maxWidth="712px"
        paddingX="12px"
        container
        flexWrap="nowrap"
        gap={2}
        className={classes.buttonsContainer}
      >
        {isFirstStep ? null : (
          <StyledButton onClick={goBack} variant="contained" color="light">
            Back
          </StyledButton>
        )}
        <StyledButton
          variant="contained"
          color="primary"
          type="submit"
          onClick={goForward}
          sx={{ ml: 'auto' }}
        >
          {isFirstStep
            ? 'Start Application'
            : isLastStep
            ? 'Finish Application'
            : 'Next'}
        </StyledButton>
      </Grid>
    </Grid>
  )
}

export const checkIsEnglish = (text: string) => {
  return text.toLowerCase() === 'english'
}
